/**
 * Formatierung fuer die Vertriebsseiten. Bisher hatte jede Seite ihre eigene
 * euro()/datum()-Kopie mit leicht anderen Regeln.
 */

export const euro = (wert: number | null | undefined, waehrung = 'EUR', nachkommastellen = 0) =>
  new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: waehrung || 'EUR',
    maximumFractionDigits: nachkommastellen,
    minimumFractionDigits: nachkommastellen,
  }).format(wert || 0);

const parse = (wert?: string | null): Date | null => {
  if (!wert) return null;
  const d = new Date(wert);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** 22.09.2026 */
export const datum = (wert?: string | null, leer = '—') => {
  const d = parse(wert);
  return d ? d.toLocaleDateString('de-DE') : leer;
};

/** 22.09.2026, 14:05 */
export const zeit = (wert?: string | null, leer = '—') => {
  const d = parse(wert);
  return d
    ? d.toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : leer;
};

/** 22. September 2026 */
export const tagLang = (wert?: string | null, leer = '') => {
  const d = parse(wert);
  return d ? d.toLocaleDateString('de-DE', { day: '2-digit', month: 'long', year: 'numeric' }) : leer;
};

/** "gerade eben", "vor 3 h", "vor 2 Tagen" */
export const her = (wert?: string | null, leer = '—') => {
  const d = parse(wert);
  if (!d) return leer;
  const h = (Date.now() - d.getTime()) / 36e5;
  if (h < 1) return 'gerade eben';
  if (h < 48) return `vor ${Math.round(h)} h`;
  return `vor ${Math.round(h / 24)} Tagen`;
};

/** "in 3 Tagen", "heute", "seit 2 Tagen überfällig" */
export const faelligkeit = (wert?: string | null): { text: string; ueberfaellig: boolean } | null => {
  const d = parse(wert);
  if (!d) return null;
  const heute = new Date();
  heute.setHours(0, 0, 0, 0);
  const ziel = new Date(d);
  ziel.setHours(0, 0, 0, 0);
  const tage = Math.round((ziel.getTime() - heute.getTime()) / 864e5);
  if (tage === 0) return { text: 'heute', ueberfaellig: false };
  if (tage === 1) return { text: 'morgen', ueberfaellig: false };
  if (tage > 1) return { text: `in ${tage} Tagen`, ueberfaellig: false };
  if (tage === -1) return { text: 'seit gestern überfällig', ueberfaellig: true };
  return { text: `seit ${-tage} Tagen überfällig`, ueberfaellig: true };
};

export const istUeberfaellig = (wert?: string | null) => {
  const d = parse(wert);
  return Boolean(d && d.getTime() <= Date.now());
};

export const isoTag = (wert?: string | null) => (wert ? String(wert).slice(0, 10) : '');

export const zahl = (n: number | null | undefined) => (n ?? 0).toLocaleString('de-DE');

/** Fehlertext aus einer Axios-Antwort oder einem Error. */
export const fehlerText = (e: any, standard: string) =>
  e?.response?.data?.error || e?.response?.data?.message || e?.message || standard;
